export default __webpack_public_path__ + "static/media/736418F0-D7D3-4BC4-AB83-360CF25A684E_1_105_c.9bf4cf89.jpeg";